import {
  AfterViewInit,
  Component,
  Type,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalComponent implements AfterViewInit {
  public title: string;
  public componentType: Type<any>;
  @ViewChild('container', { read: ViewContainerRef })
  container!: ViewContainerRef;
  private canLoad = true;
  constructor(
    private modalService: ModalService
  ) {}

  public close() {
    this.canLoad = true;
    this.modalService.close();
  }

  public ngAfterViewInit(): void {
    if (this.canLoad && !!this.container) {
      this.canLoad = false;
      this.loadComponent();
    }
  }

  private loadComponent(): void {
    this.container.clear();
    this.container.createComponent(this.componentType);
  }
}
